import { CategoryDetails } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetCategoryDetailsResponse } from "../schema/GetCategoryDetailsResponse";
import { mapCategoryDetails } from "../../mappers/partsServices/categoryDetailsMapper";

export const getCategoryDetails = async (slugCategory: string): Promise<CategoryDetails> => {

    const client = ApiClient.getInstance()
    const response = await client.get<GetCategoryDetailsResponse>(`parts-services/${slugCategory}`)

    return mapCategoryDetails(response.category);
}